import Images from "../utils/Images";

export const blogTopics = [
  "General",
  "Awareness & Education",
  "Product Education",
  "Promotional",
  "Success Stories",
];

export const blogPosts = [
  {
    id: "why-insure-short-trips",
    title: "Why Every Road Trip Needs Insurance (Even Short Ones)",
    excerpt:
      "Trips are unpredictable: from flat tyres to delays, accidents and schedule changes. Microinsurance keeps you protected throughout.",
    date: "26 Mar 2025",
    minutes: 7,
    topic: "General",
    image: Images.taxi,
    content: [
      "Even the shortest trips come with risks—minor accidents, missing items, or unexpected medical needs. Trip-based microinsurance provides affordable cover that activates when you travel and ends when you arrive.",
      "With embedded products, your policy is bundled into your ticket. That means no extra forms, quick checkout, and protection that's designed for everyday commuters as well as weekend travellers.",
      "Whether you use USSD or buy from a partner operator, activation takes seconds and claims are simple. Think of it as peace of mind for every ride.",
    ],
  },
  {
    id: "trip-based-insurance-ghana",
    title: "How Trip‑Based Insurance Works in Ghana (And Why it’s Game‑Changing)",
    excerpt:
      "A simple, embedded cover that travels with your ticket—pay only for what you use, when you travel.",
    date: "26 Mar 2025",
    minutes: 7,
    topic: "Awareness & Education",
    image: Images.intercity_travel,
    content: [
      "Trip-based insurance aligns protection with actual journeys. Instead of annual premiums, you pay a tiny fee only when you move.",
      "This model is ideal for commuters and intercity travellers alike, and integrates directly with transport operators, ticketing apps and USSD flows.",
      "The result is wider access, simpler onboarding, and fair, transparent pricing.",
    ],
  },
  {
    id: "protect-your-journey",
    title: "Protect Your Journey: 4 Reasons to Buy Microinsurance Before You Road Trip",
    excerpt:
      "From medical emergencies to lost luggage, here’s why having a policy gives you peace of mind.",
    date: "26 Mar 2025",
    minutes: 7,
    topic: "Product Education",
    image: Images.daily_commuter,
    content: [
      "Reason 1: Health and safety support when you need it the most.",
      "Reason 2: Loss or damage to belongings can be partially covered depending on plan.",
      "Reason 3: Ticket changes and disruptions happen—your policy helps cushion the impact.",
      "Reason 4: Claims are digital-first and designed to be quick.",
    ],
  },
  {
    id: "ussd-insure-60s",
    title: "How to Use USSD to Insure Your Road Trip in Under 60 Seconds",
    excerpt:
      "No app? No problem. Dial, select, confirm—your cover is active before you set off.",
    date: "26 Mar 2025",
    minutes: 7,
    topic: "Promotional",
    image: Images.okada,
    content: [
      "Dial the short code, choose your cover, confirm, and receive instant confirmation—it's that simple.",
      "USSD works on any phone and any network, making protection accessible to everyone.",
    ],
  },
  {
    id: "how-tripsecure-works",
    title: "How Trip Secure Works: From Registration to Claim in 5 Steps",
    excerpt:
      "We walk you through sign‑up, choosing cover, activation, and making a claim if something goes wrong.",
    date: "26 Mar 2025",
    minutes: 7,
    topic: "Product Education",
    image: Images.taxi,
    content: [
      "1. Register with phone number.",
      "2. Choose a plan that matches your travel type.",
      "3. Activate before you set off.",
      "4. Travel with confidence.",
      "5. If something happens, file a claim digitally and get support.",
    ],
  },
  {
    id: "future-of-road-travel",
    title: "The Future of Road Travel: Smart, Insured, and Accessible to All",
    excerpt:
      "Embedded insurance and digital distribution are transforming safety for commuters across Africa.",
    date: "26 Mar 2025",
    minutes: 7,
    topic: "Success Stories",
    image: Images.intercity_travel,
    content: [
      "Insurance is moving closer to the point of need—inside the ticket, app, or kiosk. That reduces friction and expands inclusion.",
      "As distribution scales, pricing improves and cover becomes smarter and more personalised.",
    ],
  },
];


